import { useContext } from 'react';
import { PublicationContext } from '../context';

export function usePublications() {
  const context = useContext(PublicationContext);
  return { ...context };
}
